import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  collection,
  getDocs,
  addDoc,
  deleteDoc,
  doc,
  query,
  where,
  orderBy,
} from "firebase/firestore";
import { db } from "../firebase";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default function GroupDetails({ user }) {
  const { memberId } = useParams();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  /* ================= FETCH (FIXED) ================= */
  useEffect(() => {
    if (!memberId) return;

    const fetchGroups = async () => {
      try {
        const q = query(
          collection(db, "groups"),
          where("memberId", "==", memberId),
          orderBy("createdAt", "asc")
        );

        const snap = await getDocs(q);
        const data = snap.docs.map(d => ({
          id: d.id,
          ...d.data(),
        }));

        setRows(data);
      } catch (err) {
        console.error("Group fetch error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchGroups();
  }, [memberId]);

  /* ================= ADD ROW ================= */
  const addRow = () => {
    setRows(prev => [
      ...prev,
      {
        groupName: "",
        groupDate: "",
        groupDone: "",
        groupLeft: "",
        remark: "",
        isNew: true, // 👈 important
      },
    ]);
  };

  /* ================= SAVE ROW ================= */
  const saveRow = async index => {
    const row = rows[index];

    if (!row.groupName) {
      alert("Group Name required");
      return;
    }

    // 🔁 Already saved → do nothing
    if (row.id) {
      alert("Already saved");
      return;
    }

    const docRef = await addDoc(collection(db, "groups"), {
      memberId,
      groupName: row.groupName,
      groupDate: row.groupDate,
      groupDone: Number(row.groupDone || 0),
      groupLeft: Number(row.groupLeft || 0),
      remark: row.remark || "",
      createdAt: new Date(),
      entryBy: user.name,
    });

    const updated = [...rows];
    updated[index] = { ...row, id: docRef.id, isNew: false };
    setRows(updated);

    alert("Saved ✔");
  };

  /* ================= DELETE ROW ================= */
  const deleteRow = async index => {
    if (user.role !== "ADMIN") {
      alert("Only admin can delete");
      return;
    }

    const row = rows[index];
    if (!window.confirm("Delete this row?")) return;

    if (row.id) {
      await deleteDoc(doc(db, "groups", row.id));
    }

    // ✅ UI se bhi remove
    setRows(prev => prev.filter((_, i) => i !== index));
  };

  /* ================= INPUT ================= */
  const handleChange = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;
    setRows(updated);
  };

  /* ================= PDF ================= */
  const downloadPDF = () => {
    const pdf = new jsPDF();
    pdf.text(`Group Details - ${memberId}`, 14, 10);

    pdf.autoTable({
      startY: 20,
      head: [[
        "Sr",
        "Group Name",
        "Group Date",
        "Group Done",
        "Group Left",
        "Remark",
      ]],
      body: rows.map((r, i) => [
        i + 1,
        r.groupName,
        r.groupDate,
        r.groupDone,
        r.groupLeft,
        r.remark,
      ]),
    });

    pdf.save(`Group_${memberId}.pdf`);
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <div className="container-fluid">
      <h4>Group Details : {memberId}</h4>

      <div className="mb-2 d-flex gap-2">
        <button className="btn btn-primary" onClick={addRow}>
          ➕ Add Row
        </button>

        <button className="btn btn-danger" onClick={downloadPDF}>
          📄 PDF / Print
        </button>
      </div>

      <table className="table table-bordered">
        <thead className="table-warning text-center">
          <tr>
            <th>Sr</th>
            <th>Group Name</th>
            <th>Group Date</th>
            <th>Group Done</th>
            <th>Group Left</th>
            <th>Remark</th>
            <th>💾</th>
            <th>❌</th>
          </tr>
        </thead>

        <tbody>
          {rows.map((r, i) => (
            <tr key={i}>
              <td>{i + 1}</td>

              <td>
                <input
                  className="form-control"
                  value={r.groupName}
                  onChange={e =>
                    handleChange(i, "groupName", e.target.value)
                  }
                />
              </td>

              <td>
                <input
                  type="date"
                  className="form-control"
                  value={r.groupDate}
                  onChange={e =>
                    handleChange(i, "groupDate", e.target.value)
                  }
                />
              </td>

              <td>
                <input
                  className="form-control"
                  value={r.groupDone}
                  onChange={e =>
                    handleChange(i, "groupDone", e.target.value)
                  }
                />
              </td>

              <td>
                <input
                  className="form-control"
                  value={r.groupLeft}
                  onChange={e =>
                    handleChange(i, "groupLeft", e.target.value)
                  }
                />
              </td>

              <td>
                <input
                  className="form-control"
                  value={r.remark}
                  onChange={e =>
                    handleChange(i, "remark", e.target.value)
                  }
                />
              </td>

              <td className="text-center">
                {!r.id && (
                  <button
                    className="btn btn-success btn-sm"
                    onClick={() => saveRow(i)}
                  >
                    💾
                  </button>
                )}
              </td>

              <td className="text-center">
                {user.role === "ADMIN" && (
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => deleteRow(i)}
                  >
                    ❌
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}